import { supabase } from './supabaseClient.js';

/**
 * Capa de acceso al maestro de códigos de parada (incluye la matriz de
 * tiempos de cambio de referencia). Fuente original: PAROS/LISTADO MAESTRO
 * CODIGOS PAROS USP.xlsx, cargado en la tabla codigos_paro (ver
 * supabase/schema.sql y supabase/seed_paros.sql).
 */
export async function fetchCodigosParo() {
  const { data, error } = await supabase
    .from('codigos_paro')
    .select('codigo, descripcion_motivo, componente_motivo, origen_motivo, tipo_parada, tiempo_estandar_min')
    .order('codigo', { ascending: true });
  if (error) throw error;
  return data || [];
}
